import { ColorTheme } from "/Models/Models/ColorTheme";
import "./WebcruiterLinkItem.scss";
import { LinkProps } from "/Models/Generated/LinkProps";
import { ArrowLineUpRightIcon } from "/App.Components";

interface Props extends LinkProps {
  externalLinkAriaLabel?: string;
}

const WebcruiterLinkItem = ({
  href,
  text,
  isExternal,
  externalLinkAriaLabel,
}: Props) => {
  if (!href) {
    return null;
  }

  return (
    <a
      className="webcruiter-link-item-norad"
      target={isExternal ? "_blank" : ""}
      href={href}
    >
      <div className="webcruiter-link-item-norad__icon">
        <ArrowLineUpRightIcon
          size="20"
          thickness="Reg"
          color={ColorTheme.default}
          ariaLabel={externalLinkAriaLabel}
        />
      </div>
      <div className="webcruiter-link-item-norad__text">
        <span>{text}</span>
      </div>
    </a>
  );
};

export default WebcruiterLinkItem;
